module.exports = __webpack_public_path__ + "img/globe.f67b9764.jpg";